import { Box } from '@dtx-company/shared-components/src'
import { CreateFlowcodeState } from '@app/code/src/redux/slices/createFlowcodeSlice'
import { DownloadButtons } from './DownloadButtons'
import { useCreateFlowcodeForm } from '../CreateFlowcodeForm/CreateFlowcodeForm.hooks'
import { useSelector } from 'react-redux'
import React from 'react'
import styled from 'styled-components'

const ButtonsBox = styled(Box)`
  align-items: center;
  display: flex;
  width: 200px;
  justify-content: flex-start;
  margin-top: 12px;
`

export const LoggedInDownloadStep = (): JSX.Element => {
  const {
    isDestinationValidating,
    formState: { isSubmitting }
  } = useCreateFlowcodeForm()

  const loadingCreateFlowcode = useSelector(
    (state: { createFlowcode: CreateFlowcodeState }) => state.createFlowcode.loadingCreateFlowcode
  )

  const isLoading = isSubmitting || isDestinationValidating || loadingCreateFlowcode
  return (
    <ButtonsBox data-testid="logged-in-download-step">
      <DownloadButtons loading={isLoading} emailIsSSOEnabled={false} />
    </ButtonsBox>
  )
}
